/** Official FD-CIC tillage values stored in the DB / sent to Excel. */
export const TILLAGE_STORAGE_VALUES = [
  'Reduced till',
  'No till',
  'None of the above',
] as const;

export type TillageStorageValue = (typeof TILLAGE_STORAGE_VALUES)[number];

/** Friendlier UI labels; storage values stay FD-CIC-compatible. */
const TILLAGE_DISPLAY_LABELS: Record<string, string> = {
  'Reduced till': 'Reduced till',
  'No till': 'No till',
  'None of the above': 'Conventional Tillage',
};

/** Map legacy/stored tillage to an official FD-CIC storage value. */
export function normalizeTillage(value?: string | null): string {
  if (!value) return '';
  const v = value.trim().toLowerCase();
  if (v.startsWith('reduced')) return 'Reduced till';
  if (v.startsWith('no till') || v.startsWith('continuous no till')) {
    return 'No till';
  }
  if (v.startsWith('none of the above') || v.startsWith('conventional')) {
    return 'None of the above';
  }
  if (v.startsWith('not reduced')) return 'None of the above';
  return (TILLAGE_STORAGE_VALUES as readonly string[]).includes(value)
    ? value
    : '';
}

/** UI-only display label for a stored tillage value. */
export function formatTillageForDisplay(value?: string | null): string {
  const normalized = normalizeTillage(value);
  if (!normalized) return value?.trim() || '';
  return TILLAGE_DISPLAY_LABELS[normalized] || normalized;
}
